// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContactForm_form__y15Vs {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ContactForm_inputs__AVvcn {
  width: 100%;
  column-count: 2;
  gap: 20px;
  margin: 0 0 28px;
}

.ContactForm_input__fiGW8 {
  position: relative;
}
.ContactForm_input__fiGW8:not(:last-child) {
  margin-bottom: 20px;
}
.ContactForm_input__fiGW8 input {
  width: 100%;
}
.ContactForm_input__fiGW8 .ContactForm_suffix__VQs5k {
  position: absolute;
  right: 8px;
  bottom: 2px;
  transform: translateY(-50%);
  height: 18px;
}

.ContactForm_contract__36rUb {
  width: 100%;
  margin-bottom: 32px;
}

.ContactForm_button__ZaauD {
  width: 200px;
}

@media screen and (max-width: 600px) {
  .ContactForm_inputs__AVvcn {
    column-count: 1;
    margin-bottom: 20px;
  }
  .ContactForm_button__ZaauD {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Claims/ClaimApplication/ContactForm/ContactForm.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAIF;;AADA;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;AAIF;;AADA;EACE,kBAAA;AAIF;AAHE;EACE,mBAAA;AAKJ;AAFE;EACE,WAAA;AAIJ;AADE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;AAGJ;;AACA;EACE,WAAA;EACA,mBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE;IACE,eAAA;IACA,mBAAA;EAEF;EACA;IACE,WAAA;EACF;AACF","sourcesContent":["@use 'styles/sizes.scss';\n@use 'styles/colors.scss';\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.inputs {\n  width: 100%;\n  column-count: 2;\n  gap: 20px;\n  margin: 0 0 28px;\n}\n\n.input {\n  position: relative;\n  &:not(:last-child) {\n    margin-bottom: 20px;\n  }\n\n  input {\n    width: 100%;\n  }\n\n  .suffix {\n    position: absolute;\n    right: 8px;\n    bottom: 2px;\n    transform: translateY(-50%);\n    height: 18px;\n  }\n}\n\n.contract {\n  width: 100%;\n  margin-bottom: 32px;\n}\n\n.button {\n  width: 200px;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .inputs {\n    column-count: 1;\n    margin-bottom: 20px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"form": `ContactForm_form__y15Vs`,
	"inputs": `ContactForm_inputs__AVvcn`,
	"input": `ContactForm_input__fiGW8`,
	"suffix": `ContactForm_suffix__VQs5k`,
	"contract": `ContactForm_contract__36rUb`,
	"button": `ContactForm_button__ZaauD`
};
export default ___CSS_LOADER_EXPORT___;
